import React, { useContext, useMemo } from "react";
import { useSelector } from "react-redux";

import { getIsPricelessShop } from "@selectors/store";

const emptyFunction = () => {};
const emptyObj = {};

export const productInfoDefaultObj = {
  hidePriceDetail: false,
  hideBrandLink: false,
  hideVariantSelectionSection: false,
  isViewOnlyMode: false,
  showAddToBox: false,
  renderCustomVariantSelectionSection: emptyFunction,
  renderCatalogModeFooterLinks: emptyFunction,
  onSuccessCallback: emptyFunction,
  modalClasses: emptyObj,
};

const ProductInfoContext = React.createContext(productInfoDefaultObj);

export const useProductInfoContext = () => useContext(ProductInfoContext);

const ProductInfoProvider = ({ children, data = productInfoDefaultObj }) => {
  const isPricelessShop = useSelector(getIsPricelessShop);
  const productDetailContextValues = useMemo(() => {
    return {
      ...data,
      hidePriceDetail: isPricelessShop || data.hidePriceDetail,
    };
  }, [data, isPricelessShop]);
  return (
    <ProductInfoContext.Provider value={productDetailContextValues}>
      {children}
    </ProductInfoContext.Provider>
  );
};

export default ProductInfoProvider;
